import { render, staticRenderFns } from "./JoinComplete.vue?vue&type=template&id=6353cbf1&"
import script from "./JoinComplete.vue?vue&type=script&lang=ts&"
export * from "./JoinComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports